export default "__VITE_ASSET__49f0c78d__"